const getters = {
  token: state => state.user.token,
  language:state=>state.user.lang,
}
export default getters
